import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { api } from "../api";
import AaryaMark from "./AaryaMark";

export default function TermsSheet({ open, onClose }) {
  const [terms, setTerms] = useState(null);

  useEffect(() => {
    if (open && !terms) {
      api.get("/meta/terms").then((r) => setTerms(r.data)).catch(() => {});
    }
  }, [open, terms]);

  if (!open) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black/50 z-50 flex items-end justify-center" onClick={onClose}
      >
          <motion.div
            initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 28, stiffness: 280 }}
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-[430px] max-h-[92dvh] bg-sand-50 rounded-t-[32px] flex flex-col"
            data-testid="terms-sheet"
          >
            <div className="flex items-center justify-between px-6 pt-5 pb-3 border-b border-sand-200">
              <div className="flex items-center gap-3">
                <AaryaMark size={32}/>
                <div>
                  <p className="font-display text-xl text-ink-900 leading-none">Terms &amp; Conditions</p>
                  <p className="text-[10px] tracking-[0.18em] uppercase text-ink-500 mt-1">An IndoBlitz product</p>
                </div>
              </div>
              <button onClick={onClose} data-testid="terms-close"
                className="h-9 w-9 rounded-full bg-white border border-sand-200 flex items-center justify-center">
                <X size={16}/>
              </button>
            </div>
            <div className="overflow-y-auto px-6 py-5 text-[13.5px] text-ink-700 leading-relaxed">
              {!terms && <p className="text-ink-500">Loading…</p>}
              {terms && (
                <>
                  <div className="text-[11px] tracking-[0.18em] uppercase text-terracotta-600 font-semibold">{terms.publisher} · v{terms.version}</div>
                  <pre className="mt-2 whitespace-pre-wrap font-sans text-[13.5px] text-ink-700 leading-relaxed">
                    {terms.text.trim()}
                  </pre>
                </>
              )}
            </div>
          </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
